const topbar = {
    docs: 'ドキュメント',
    help: 'ヘルプ',
    subscription: 'サブスクリプション',
};
export default Object.freeze(topbar);
